var React = require('react');

function WindowsIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#000","strokeWidth":"1.2"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M10.18 11.533l9.19.014-.004 7.774-9.174-1.295-.012-6.493zm-9.544-.102l6.616.042.005 6.268-6.62-.908V11.43zm6.619-9.076l.002 6.262-6.62.037-.006-5.399 6.624-.9zM19.365.708v7.815l-9.172.074v-6.55L19.365.708z","transform":"translate(-190 -746) translate(190 741) translate(0 5)"}))))));
}

WindowsIconInline.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21"};

module.exports = WindowsIconInline;

WindowsIconInline.default = WindowsIconInline;
